import { useContext } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./i18n";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/style.scss";

import LogInWrapper from "./pages/logInWrapper.jsx";
import NewRegistration from "./pages/NewRegistration.jsx";

import Dashboard from "./pages/Dashboard.jsx";
import RecordingPledge from "./pages/RecordingOfPledges.jsx";
import AppContext from "./context/AppContext";
import UpdateScore from "./pages/UpdateIccScore.jsx";
import LiveRanking from "./pages/LiveRanking.jsx";
import BlogsAndArticles from "./pages/blogs.jsx";
import BlogDetails from "./pages/blogDetails.jsx";
import MyProfile from "./pages/myProfile.jsx";
import Header from "./components/layout/header.jsx";
import Footer from "./components/layout/footer.jsx";
import Forum from "./pages/forum.jsx";
import ForumDetails from "./pages/forumDetails.jsx";
import ProtectedRoute from "./protected-route/ProtectedRoute.js";
import VideosSection from "./pages/videos.jsx";
import AudioSection from "./pages/audio.jsx";
import ViewTransactions from "./pages/viewTransactions.jsx";
import NotificationDetails from "./components/my-profile/notificationDetails.jsx";
import Resources from "./pages/resources.jsx";
import ContactUs from "./pages/contactUs.jsx";
import Quotes from "./pages/quotes.jsx";
import LiveScoreUpdates from "./components/common/liveScoreUpdates.jsx";
import TemplesStats from "./pages/TemplesStats.jsx";
import Unsubscribe from "./pages/unsubscribe.jsx";
import ScheduleCalendar from "./pages/ScheduleCalendar.jsx";
import MediaPage from "./pages/mediaPage.jsx";
import MediaHistoryComponent from "./components/common/mediaUploadHistory.jsx";
import WHNF from "./pages/WHNF.jsx";
import DownloadPosters from "./pages/DownloadPosters.jsx";


export default function App() {
  const { user } = useContext(AppContext);
  const location = useLocation();

  let wrapperClass = "children-components";

  if (user === null) {
    if (location.pathname === "/login") {
      wrapperClass = "login-background-image login-fullscreen"; // → 100vh
    } else if (location.pathname === "/WHNF") {
      wrapperClass = "login-background-image whnf-background"; // → 100%
    } else {
      wrapperClass = "login-background-image posterrrs-background"
    }
  }

  else {
    if (location.pathname === "/") {
      wrapperClass = "children-components dashboard-bg";
    }
  }

  return (
    <HelmetProvider>
      {user && <Header />}
      <div className={wrapperClass}>
        {user && <LiveScoreUpdates />}
        <Routes>
          {user != null && <Route exact path="/login" element={<ProtectedRoute children={<LogInWrapper />} />} />}
          <Route exact path="/login" element={<LogInWrapper />}></Route>
          <Route exact path="/landerz" element={<LogInWrapper />}></Route>
          <Route exact path="/new-registration" element={<NewRegistration />}></Route>
          <Route path="/unsubscribe/:id" element={<Unsubscribe />} />
          <Route path="/" element={<ProtectedRoute children={<Dashboard />} />} />
          <Route path="/update-score" element={<ProtectedRoute children={<UpdateScore />} />} />
          <Route path="/temple-stats" element={<ProtectedRoute children={<TemplesStats />} />} />
          <Route exact path="/recording-pledge" element={<ProtectedRoute children={<RecordingPledge />} />} />
          <Route exact path="/live-ranking" element={<ProtectedRoute children={<LiveRanking />} />} />
          <Route exact path="/blogs" element={<ProtectedRoute children={<BlogsAndArticles />} />} />
          <Route exact path="/blogs/:id" element={<ProtectedRoute children={<BlogsAndArticles />} />} />
          <Route exact path="/blog-details/:id" element={<ProtectedRoute children={<BlogDetails />} />} />
          <Route path="/my-profile" element={<ProtectedRoute children={<MyProfile />} />} />
          <Route exact path="/forum" element={<ProtectedRoute children={<Forum />} />} />
          <Route exact path="/forum-details/:id" element={<ProtectedRoute children={<ForumDetails />} />} />
          <Route exact path="/videos" element={<ProtectedRoute children={<VideosSection />} />} />
          <Route exact path="/audios" element={<ProtectedRoute children={<AudioSection />} />} />
          <Route exact path="/view-history" element={<ProtectedRoute children={<MediaHistoryComponent />} />} />
          <Route exact path="/notification-details/:id" element={<ProtectedRoute children={<NotificationDetails />} />} />
          <Route exact path="/posters" element={<Resources />} />
          <Route exact path="/contact-us" element={<ProtectedRoute children={<ContactUs />} />} />
          <Route exact path="/upload-media" element={<ProtectedRoute children={<MediaPage />} />} />
          <Route exact path="/schedule-calendar" element={<ProtectedRoute children={<ScheduleCalendar />} />} />
          <Route exact path="/quotes" element={<ProtectedRoute children={<Quotes />} />} />
          {/* <Route exact path="/WHNF" element={<WHNF/>}/> */}
          {/* <Route exact path="/posters" element={<DownloadPosters />} /> */}
        </Routes>
      </div>
      {user != null && <Footer />}
    </HelmetProvider>
  );
}
